import React, { FC, FormEvent } from 'react';
import { TranslationProps } from '../../../contexts/TranslationContext';
import { BaseForm, FetchInfos, FormKeys } from '../fa-interfaces';
import FormAddressInput from './FormAddressInput';
import { fetchSearchAddress } from '../../../service/address.api';
import { Pays, SearchAddress } from '../../../interfaces-base';
import FormAddressAutocomplete from './FormAddressAutocomplete';
import './css/section-location.css';

interface Props {
  state: BaseForm;
  country: Pays;
  errorList: Partial<Record<FormKeys, undefined | string>>;
  zipFetchState?: FetchInfos;
  onChange: (field: keyof BaseForm, value: string) => void;
}

const SectionLocation: FC<Props & TranslationProps> = ({ textsContent, state, country, errorList, zipFetchState, onChange }): JSX.Element => {

  const requestSearchAddress = async (search: string, signal: AbortSignal, cleanFn: () => void): Promise<JSX.Element[]> => {
    return fetchSearchAddress(search, 10, signal)
      .then((addresses) => {
        const list = addresses
          .map((address) => {
            const key = `${address.name}-${address.zipCode}-${address.city}`;
            return (
              <div key={key.replace(/ /g, '_').toLowerCase()} className="fa-address-item" onClick={() => handleClickAddress(address, cleanFn)}>
                <span>{address.name}, {address.zipCode} {address.city}</span>
              </div>
            );
          });
        list.length > 0 && list.push(<div key="fa-address-not-found" className="fa-address-item" onClick={cleanFn}>{textsContent?.['SHIPPING_FORM_ADDRESS_NOT_IN_LIST']}</div>);
        return list;
      })
      .catch(() => []);
  };


  const handleClickAddress = (address: SearchAddress, cleanFn: () => void): void => {
    onChange('adresse', address.name);
    onChange('code_postal', address.zipCode);
    onChange('ville', address.city);
    cleanFn();
  };

  const defaultHandleChange = (key: keyof BaseForm) => (event: FormEvent<HTMLInputElement>) => {
    const { target } = event;
    if (target instanceof HTMLInputElement) {
      onChange(key, target.value);
    }
  };

  return (
    <>
      <FormAddressAutocomplete
        label={textsContent?.['SHIPPING_FORM_ADDRESS']}
        value={state.adresse}
        name="adresse"
        errorMessage={errorList['adresse']}
        request={country.codePays === 'FR' || country.codePaysTva === 'FR' ? requestSearchAddress : undefined}
        maxLength={30}
        onChange={defaultHandleChange('adresse')}
      />
      <FormAddressInput
        label={textsContent?.['SHIPPING_FORM_ADDRESS_ADDITIONAL']}
        value={state.adresse2}
        name="adresse2"
        maxLength={30}
        onChange={defaultHandleChange('adresse2')}
      />
      <div className="fa-grid">
        <FormAddressInput
          label={textsContent?.['SHIPPING_FORM_POSTALCODE']}
          errorMessage={errorList['code_postal']}
          loading={zipFetchState?.loading}
          value={state.code_postal}
          name="code_postal"
          onChange={defaultHandleChange('code_postal')}
        />
        <FormAddressInput
          label={textsContent?.['SHIPPING_FORM_CITY']}
          value={state.ville}
          name="ville"
          errorMessage={errorList['ville']}
          onChange={defaultHandleChange('ville')}
        />
      </div>
    </>
  );
};

export default SectionLocation;